import axios from 'axios';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";

import userTypeName from "../../../../constants/userType";

export function useUserView(userId, token, profileEdit) {
  return useQuery(['userView', userId], async () => {
    const response = await axios.get(`/api/user/view/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response?.data?.status === "userDeleted") {
      toast.error('This user is deleted!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // navigate("/user/myteam/list");
      return;
    }
    return response.data;
  },
    {
      enabled: !profileEdit, // Use this to conditionally enable or disable the query
      staleTime: 5 * 60 * 1000,          // 5 mins - prevents refetching if data is still fresh
      cacheTime: 10 * 60 * 1000,         // 10 mins - keeps data in cache
      refetchOnWindowFocus: false,       // Prevents refetch on tab switch
      refetchOnMount: false,             // Prevents auto refetch on mount
      retry: false,    // Disable retry on failure
    }
  );
}

export function useUserType() {
  const { user } = useSelector((state) => state.auth);

  return useQuery('userType', async () => {
    const response = await axios.get('/api/user-type');
    return response.data.filter((role) => {
      if (role._id === userTypeName.Collaborator || role._id === userTypeName.Business) {
        return false;
      }
      if (user?.role_id === userTypeName.Admin && role._id === userTypeName.Super_Admin) {
        return false;
      }
      return true;
    });
  });
}

export function useWXCompanies() {
  return useQuery('wxCompanies', async () => {
    const response = await axios.get('/api/get-wx-comapies');
    return response.data;
  }, { staleTime: 5 * 60 * 1000, cacheTime: 10 * 60 * 1000, refetchOnWindowFocus: false });
}

export function useUserDepartments() {
  return useQuery('userDepartments', async () => {
    const response = await axios.get('/api/user-department');
    return response.data;
  });
}

export function useContractTypes() {
  return useQuery('contractTypes', async () => {
    const response = await axios.get('/api/contract-type');
    return response.data;
  });
}

export function useOverheadCostTypes() {
  return useQuery('overheadCostTypes', async () => {
    const response = await axios.get('/api/overhead-cost-type');
    return response.data;
  });
}